import * as yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();
let createPickupRequestValidationForm = yup.object().shape({
  // vehicle: yup.string().required("Vehicle is required"),
  // driver: yup.string().required("Driver is required"),
  sender_name: yup.string().required("Sender name is required"),
  sender_primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  sender_address: yup.string().required("Sender Address is required"),
  order_count: yup
    .number()
    .typeError("Please select at least one order")
    .required("Please select at least one order")
    .moreThan(0, "Please select at least one order"),
});
let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact is required")
    .transform(function (value) {
      if (value && !value.startsWith("+977")) {
        return "+977" + value;
      }
      return value;
    }),
  license_number: yup.string().required("License Number is required"),
});
let createOrderValidationForm = yup.object().shape({
  destination: yup.string().required("Destination is required"),
  full_name: yup.string().required("Full Name is required"),
  address: yup.string().required("Address is required"),
  phone_number: yup.string().required("Phone number is required"),
  weight: yup.string().required("Weight is required"),
  cod: yup.string().required("Cod is required"),
  service_type: yup.string().required("Service Type is requried"),
});
let createRiderValidationForm = yup.object().shape({
  username: yup.string().required("Username is required"),
  full_name: yup.string().required("Full Name is required"),
  email: yup.string().email().required("Email is required"),
  mobile_number: yup
    .string()
    .required("Mobile Number is required")
    .transform(function (value) {
      if (value && !value.startsWith("+977")) {
        return "+977" + value;
      }
      return value;
    }),
  license_number: yup.string().required("License Number is required"),
  citizenship_number: yup.string().required("Citizenship Number is required"),
});
export {
  createPickupRequestValidationForm,
  createOrderValidationForm,
  vehicleValidationForm,
  createRiderValidationForm,
};
